exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".category-preparation-status-circle[data-v-3587cb50] {\n  display: block;\n  position: absolute;\n  width: 40px;\n  height: 40px;\n  top: -20px;\n  right: -20px;\n  border: 2px solid #252525;\n  border-radius: 50%;\n}", ""]);

// exports
